import { render, staticRenderFns } from "./ExcluirMetodoAutenticacaoModal.vue?vue&type=template&id=3835d4a8&scoped=true&"
import script from "./ExcluirMetodoAutenticacaoModal.vue?vue&type=script&lang=js&"
export * from "./ExcluirMetodoAutenticacaoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835d4a8",
  null
  
)

export default component.exports